import { forwardRef, type ButtonHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';
import { haptic } from '@/lib/tg';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
}

const variants = {
  primary: 'bg-brand-orange text-white hover:bg-brand-orange/90',
  secondary: 'bg-tg-secondaryBg text-tg-text hover:bg-tg-secondaryBg/80',
  ghost: 'hover:bg-tg-secondaryBg',
};

const sizes = {
  sm: 'h-9 px-3 text-sm rounded-lg',
  md: 'h-11 px-4 rounded-xl',
  lg: 'h-14 px-6 rounded-2xl text-lg',
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = 'primary', size = 'md', className, onClick, ...rest }, ref) => (
    <button
      ref={ref}
      onClick={(e) => {
        haptic('light');
        onClick?.(e);
      }}
      className={cn(
        'inline-flex items-center justify-center font-medium transition-all active:scale-[0.97] disabled:opacity-50 disabled:cursor-not-allowed',
        variants[variant],
        sizes[size],
        className,
      )}
      {...rest}
    />
  ),
);
Button.displayName = 'Button';
